import React from "react";

import styles from "./styles.modules.scss";

export const Grid = ({ children }: { children: React.ReactNode }) => (
    <div className={`grid ${styles.grid}`}>{children}</div>
);
